/**
 * @module Shop FAQs
 * @description
 */
import { useContext } from "react";
import { FuelContext } from "@/providers/fuel-provider";
import Link from "next/link";
import FAQs from "@/blocks/FAQS";
import { trackEvent } from "@/js/helpers/tracking";

/**
 * @function Component
 * @description Hero that displays headline and predictive service check
 */
const Component = () => {
  const { clickThrough } = useContext(FuelContext);

  /**
   * @function handleClick
   * @description
   */
  const handleClick = (event) => {
    const { target } = event;
    const text = target.innerHTML;
    const data = {
      elementType: "LINK",
      position: "FAQ",
      text,
      actionOutcome: "INTERNALLINK",
    };

    trackEvent({ action: "elementClicked", data, event });
  };

  return (
    <FAQs
      accordionData={[
        {
          title: "What Frontier services are available in my neighborhood?",
          content: (
            <>
              Frontier Internet services vary by location.{" "}
              <Link key="link-1" href={clickThrough} onClick={handleClick}>
                Check availability
              </Link>{" "}
              to see which plans are available at your address.
            </>
          ),
          contentRaw:
            "Frontier Internet services vary by location. Check availability to see which plans are available at your address.",
        },
        {
          title: "Do I have to sign a contract with Frontier?",
          content: (
            <>
              Select plans and Visa<sup>&reg;</sup> Reward Card offers require a
              12-month commitment. If you cancel early, a prorated early
              termination fee applies.
            </>
          ),
          contentRaw:
            "Select plans and Visa® Reward Card offers require a 12-month commitment. If you cancel early, a prorated early termination fee applies.",
        },
        {
          title: "Are there any limits to the amount of data I can use?",
          content:
            "No. You can use the internet as much as you want every month with no extra fees.",
        },
        {
          title: "What is fiber, anyway?",
          content: (
            <>
              Fiber-optic internet is a type of broadband connection that can
              send data over the internet at incredible speeds. It works by
              sending pulses of light through thin glass fibers inside a
              durable, weather resistant fiber-optic cable. This technology
              supports the fastest internet speeds available. Learn more about
              the Fiber internet plans we offer and see if{" "}
              <a href={clickThrough}>
                Frontier Fiber Internet is available at your home
              </a>
              .
            </>
          ),
          contentRaw:
            "Fiber-optic internet is a type of broadband connection that can send data over the internet at incredible speeds. It works by sending pulses of light through thin glass fibers inside a durable, weather resistant fiber-optic cable. This technology supports the fastest internet speeds available. Learn more about the Fiber internet plans we offer and see if Frontier Fiber Internet is available at your home.",
        },
        {
          title: "Does Frontier have internet and TV bundles?",
          content: (
            <>
              We’ve partnered with YouTube TV to bring you cable-free TV. With
              Frontier®️ Internet and YouTube TV, you can stream live & local
              sports, news and shows from 100+ channels including ABC, CBS, FOX,
              NBC, ESPN, FX, Disney Channel, HGTV, TNT, and more.
              <br />
              <br />
              Local and regional programming is also provided with YouTube TV,
              offering complete local network coverage in over 98% of U.S. TV
              households. Please visit the{" "}
              <Link
                target="_blank"
                key="link-2"
                href="https://streaming.frontier.com/channel-lineup/youtube?iframe"
                onClick={handleClick}
              >
                Youtube TV Channel Lineup
              </Link>{" "}
              and enter your 5-digit ZIP code for a full list of your area's
              channel lineup. Or,{" "}
              <Link
                target="_blank"
                key="link-3"
                href="https://frontier.com/shop/tv"
                onClick={handleClick}
              >
                learn more about Youtube TV
              </Link>
              .
            </>
          ),
          contentRaw:
            "We’ve partnered with YouTube TV to bring you cable-free TV. With Frontier®️ Internet and YouTube TV, you can stream live & local sports, news and shows from 100+ channels including ABC, CBS, FOX, NBC, ESPN, FX, Disney Channel, HGTV, TNT, and more. Local and regional programming is also provided with YouTube TV, offering complete local network coverage in over 98% of U.S. TV households. Please visit the Youtube TV Channel Lineup and enter your 5-digit ZIP code for a full list of your area's channel lineup. Or, learn more about Youtube TV.",
        },
      ]}
    />
  );
};

export default Component;
